import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { ContractDesignerContext } from './contexts/StoreContext'
import { createContractDesingerStore } from './store/createStore'
import { ContractDesignerStoreUpdater } from './StoreUpdater'

export const ContractDesignerStoreProvider = ({
  children
}: PropsWithChildren) => {
  const store = useCreation(() => createContractDesingerStore(), [])

  return (
    (<ContractDesignerContext value={store}>
      {children}
      <ContractDesignerStoreUpdater />
    </ContractDesignerContext>)
  );
}
